import { useState } from "react";
import { sanitizePhone, isValidPhone } from "../utils/phone.js";

const EMPTY = { label: "Home", name: "", phone: "", line1: "", line2: "", city: "", state: "", pincode: "", isDefault: false };

// Reusable address form. onSave(payload) should return { ok, error }.
export default function AddressForm({ initial, onSave, onCancel, submitLabel = "Save address" }) {
  const [form, setForm] = useState({ ...EMPTY, ...(initial || {}) });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (e) => {
    const { name, value, type, checked } = e.target;
    const next = name === "phone" ? sanitizePhone(value) : type === "checkbox" ? checked : value;
    setForm((f) => ({ ...f, [name]: next }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const phone = sanitizePhone(form.phone);
    if (!isValidPhone(phone)) {
      setError("Enter a valid 10-digit Indian mobile number (starts with 6-9).");
      return;
    }
    setBusy(true);
    const res = await onSave({ ...form, phone });
    setBusy(false);
    if (res && !res.ok) setError(res.error || "Could not save address.");
  };

  return (
    <form className="addr-form" onSubmit={submit}>
      {error && <p className="auth__error">{error}</p>}
      <div className="addr-form__row">
        <label>Label
          {/* The API only accepts these four labels — a free-text input here
              turns anything else into a confusing 400 "Invalid address label". */}
          <select name="label" value={form.label} onChange={set}>
            <option value="Home">Home</option>
            <option value="Work">Work</option>
            <option value="Farm">Farm</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>Full name<input name="name" value={form.name} onChange={set} required placeholder="Ravi Kumar" /></label>
      </div>
      <label>Phone<input name="phone" value={form.phone} onChange={set} required inputMode="numeric" maxLength={10} pattern="[6-9][0-9]{9}" title="10-digit Indian mobile number starting with 6-9" placeholder="10-digit mobile, e.g. 9876543210" /></label>
      <label>Address line 1<input name="line1" value={form.line1} onChange={set} required placeholder="Flat / house no, street" /></label>
      <label>Address line 2<input name="line2" value={form.line2} onChange={set} placeholder="Area, landmark (optional)" /></label>
      <div className="addr-form__row">
        <label>City<input name="city" value={form.city} onChange={set} required placeholder="Vijayawada" /></label>
        <label>State<input name="state" value={form.state} onChange={set} required placeholder="Andhra Pradesh" /></label>
      </div>
      <div className="addr-form__row">
        <label>Pincode<input name="pincode" value={form.pincode} onChange={set} required inputMode="numeric" maxLength={6} pattern="[0-9]{6}" title="6-digit PIN code" placeholder="520001" /></label>
        <label className="addr-form__check"><input type="checkbox" name="isDefault" checked={form.isDefault} onChange={set} /> Set as default</label>
      </div>
      <div className="addr-form__actions">
        <button type="submit" className="btn btn--primary" disabled={busy}>{busy ? "Saving…" : submitLabel}</button>
        {onCancel && <button type="button" className="btn btn--ghost" onClick={onCancel}>Cancel</button>}
      </div>
    </form>
  );
}
